import { render, staticRenderFns } from "./Timetable_editor.vue?vue&type=template&id=68013c91"
import script from "./Timetable_editor.vue?vue&type=script&lang=js"
export * from "./Timetable_editor.vue?vue&type=script&lang=js"
import style0 from "./Timetable_editor.vue?vue&type=style&index=0&id=68013c91&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports